/* global __WATCH__:false, __SERVICE_WORKER__:false */
// **************************************
// PWA: Service Worker logic
//
// TODO:
// - Custom IOS prompt message?
// **************************************

export default (logging, languageCode) => {
  const { enabled: log, clr: logClr, warn: warnClr, prep } = logging;

  // if !https don't setup SW
  if (window.location.protocol !== 'https:') {
    console.warn(`${prep} aborted : protocol not equal to https`, warnClr);
    return;
  }
  // if origin includes locale code don't setup SW
  if (window.location.href.includes(languageCode)) {
    console.warn(`${prep} aborted : ${window.location.href} includes ${languageCode}`, warnClr);
    return;
  }

  log && console.log(`${prep} Setting up service worker`, logClr);
  if ('serviceWorker' in navigator) {
    const baseURL = '/';
    const frontendURL = '/static/base/';
    navigator.serviceWorker
      .register(`${frontendURL}sw.js`, { scope: baseURL })
      .then((registration) => {
        log && console.log(`${prep} registration success`, logClr, registration);
      })
      .catch((registrationError) => {
        console.warn(`${prep} registration fail:`, warnClr, registrationError);
      });
  } else {
    log && console.warn(`${prep} not available`, warnClr);
  }
};
